import { createContext } from "react";

export interface NavigationContextProps {
	isNavigationCollapsed: boolean;
}

export const NavigationContext = createContext<NavigationContextProps>({ isNavigationCollapsed: false });
